import React, { ReactNode } from 'react'
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
import { Link, useLocation } from 'react-router-dom'

import {
    RadioOutlined as CompanyIcon,
    NotificationImportant,
    RecordVoiceOverOutlined,
    AccountCircleOutlined,
    PhoneAndroidOutlined as PhoneIcon,
    VpnKeyOutlined as VpnKeyIcon
} from '@mui/icons-material'
import {
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from '@mui/material'

import useStyles from './styles'

type MenuProps = {
    opened: boolean
    onClose: () => void
}

type MenuItem = {
    title: string,
    to: string,
    icon: ReactNode,
    isComing: boolean
}

const Menu: React.FC<MenuProps> = (props) => {
    const { opened, onClose } = props

    const classes = useStyles()

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    const location = useLocation()

    const isMenuItemActive = (route: string) => location.pathname.includes(route)

    const menuItems: MenuItem[] = [{
        title: 'Empresas',
        to: '/companies',
        icon: <CompanyIcon />,
        isComing: false
    }, {
        title: 'Campanhas',
        to: '/campaigns',
        icon: <RecordVoiceOverOutlined />,
        isComing: false
    }, {
        title: 'Usuários',
        to: '/users',
        icon: <AccountCircleOutlined />,
        isComing: false
    }, {
        title: 'Aplicativos',
        to: '/apps',
        icon: <PhoneIcon />,
        isComing: false
    }, {
        title: 'Chaves de API',
        to: '/keys',
        icon: <VpnKeyIcon />,
        isComing: false
    }]

    return (
        <Drawer
            open={opened}
            variant="temporary"
            anchor="left"
            onClose={onClose}
            className={classes.drawer}
        >
            <List className={classes.menuList}>
                {
                    menuItems.map(item => (
                        <ListItem
                            button
                            key={item.to}
                            to={item.to}
                            onClick={onClose}
                            component={Link}
                            className={`${isMenuItemActive(item.to) ? classes.listItemActive : ''}`}
                            disabled={item.isComing}
                        >
                            <ListItemIcon className={classes.menuListIcon}>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.title} />
                        </ListItem>
                    ))
                }
                <a href="https://grafana.loopert.com/?orgId=1" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <ListItem button>
                        <ListItemIcon className={classes.menuListIcon}>
                            <img src="assets/images/grafana.svg" alt="Grafana Logo" width="24" height="24"/>
                        </ListItemIcon>
                        <ListItemText primary="Grafana" />
                    </ListItem>
                </a>
            </List>
        </Drawer>
    )
}

export default Menu
